import { Button } from "devextreme-react";

export default function Arrow({
  direction,
  isVisible = true,
  ...rest
}: {
  direction: "left" | "right";
  isVisible?: boolean;
  [key: string]: any;
}) {
  if (!isVisible) return null;
  return (
    <Button stylingMode="text" {...rest}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        transform={direction === "left" ? "rotate(180 0 0)" : ""}
      >
        <path
          d="M9.83166 3.3562L17.5966 11.3351C17.6888 11.4301 17.7539 11.533 17.792 11.6438C17.8307 11.7546 17.8501 11.8734 17.8501 12C17.8501 12.1266 17.8307 12.2454 17.792 12.3562C17.7539 12.467 17.6888 12.5699 17.5966 12.6649L9.83166 20.6675C9.61661 20.8892 9.34779 21 9.02521 21C8.70263 21 8.42613 20.8813 8.19572 20.6438C7.9653 20.4063 7.8501 20.1293 7.8501 19.8127C7.8501 19.496 7.9653 19.219 8.19572 18.9815L14.9699 12L8.19572 5.01847C7.98066 4.79683 7.87314 4.52391 7.87314 4.19969C7.87314 3.87483 7.98834 3.59367 8.21876 3.3562C8.44917 3.11874 8.71799 3 9.02521 3C9.33243 3 9.60125 3.11874 9.83166 3.3562Z"
          fill="white"
        />
      </svg>
    </Button>
  );
}
